module.exports = __webpack_public_path__ + "img/lifechamps-members.39239b1a.svg";